import Vue from 'vue'
import Router from 'vue-router'
import 'weui'
import weui from 'weui.js'
import Main from '@/pages/Main'
import DownloadApp from '@/pages/DownloadApp'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(Router);
Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.prototype.weui = weui;

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Main',
    component: Main
  }, {
    path: '/app',
    name: 'DownloadApp',
    component: DownloadApp
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js